import { NAVIGATION_FORM_ERRORS } from 'core/constants/navigation.constants';
import { ENavigationFormError } from 'core/model/enums/navigation.enum';
import { TNavigationTreeDetailEditForm } from 'core/model/interfaces/navigation';
import { IServiceErrorContent } from 'core/model/interfaces/service.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleSpecificErrors } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import { getUnexpectedErrorMessages } from '../../navigation.utils';
import { INavigationState } from '../../types';

export const duplicateNavigationTree = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/duplicateNavigationTree`,
  async (data: TNavigationTreeDetailEditForm, { rejectWithValue }) => {
    try {
      const createdId = await apiService.navigation.duplicateNavigationTree(data);
      notificationService.global.success('Árbol duplicado correctamente.');
      return createdId;
    } catch (e) {
      const handledError = handleSpecificErrors(
        e,
        getUnexpectedErrorMessages('trees', 'duplicate'),
        NAVIGATION_FORM_ERRORS,
      );
      if (handledError) return rejectWithValue(handledError);

      throw e;
    }
  },
);

export const duplicateNavigationTreeReducer: TSliceExtraReducer<INavigationState> = builder =>
  builder
    .addCase(duplicateNavigationTree.pending, state => {
      state.form.loading = true;
      state.form.success = false;
      state.form.errors = {};
    })
    .addCase(duplicateNavigationTree.rejected, (state, action) => {
      state.form.loading = false;
      state.form.success = false;

      const errorContent = action.payload as IServiceErrorContent;
      if (errorContent?.code === ENavigationFormError.familyOrderFile) {
        state.form.errors.familyOrderFile = errorContent.details.join('\n\n');
      }
    })
    .addCase(duplicateNavigationTree.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
      state.form.errors = {};
    });
